import React from 'react';

export function processDiffedText(text: string) {
  let processed = text;
  processed = processed.replace(/<ins>(.*?)<\/ins>/g, '<span class="bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400 font-medium px-1 rounded-sm">$1</span>');
  processed = processed.replace(/<del>(.*?)<\/del>/g, '<span class="bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-400 line-through px-1 rounded-sm opacity-70">$1</span>');
  processed = processed.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold text-slate-900 dark:text-slate-100">$1</strong>');
  return <span dangerouslySetInnerHTML={{ __html: processed }} />;
}

export function cleanTagsFromData(data: any): any {
  if (typeof data === 'string') {
    return data
      .replace(/<del>[\s\S]*?<\/del>/gi, '')
      .replace(/<ins>([\s\S]*?)<\/ins>/gi, '$1')
      .replace(/ {2,}/g, ' ')
      .trim();
  }
  if (Array.isArray(data)) {
    return data.map(cleanTagsFromData);
  }
  if (data !== null && typeof data === 'object') {
    const res: any = {};
    for (const [k, v] of Object.entries(data)) {
      res[k] = cleanTagsFromData(v);
    }
    return res;
  }
  return data;
}
